export const environment = {
  // dangkykhoatu_api: 'http://localhost:3000/api/',
  dangkykhoatu_api: 'https://stagingapi.dangky.clbcucvang.com/api/',
  loginUser: 'auth/login',
  logoutUser: 'auth/logout',
  masterDataGroups: 'master-data/groups',
  masterDataLHLGroupNames: 'master-data/lhl-group-names',
  masterDataLHLClassNamesByGroupName: 'master-data/lhl-class-names',
  masterDataProvinces: 'master-data/provinces',
  masterDataCommuneProvinceName: 'master-data/commune-by-province-name',
  myRegistrations: 'dynamic-form-response/my-registrations',
  myRegistrationsDetail: 'dynamic-form-response/my-registrations/',
  searchKSLHL: 'clb-la-hau-la/search',
  searchKSLHLOnboardChecklist: 'clb-la-hau-la/search-ob-checklist',
  searchKSLHLTemp: 'clb-la-hau-la/search-temp',
  searchKSLHLByKhoi: 'clb-la-hau-la/search-khoi',
  searchKSLHLByLop: 'clb-la-hau-la/search-khoi-lop',
  searchKSLHLByDT: 'clb-la-hau-la/search-dt',
  searchKSLHLTempByDT: 'clb-la-hau-la/search-temp-dt',
  searchBTThangCB: 'lhl_bai_tap_rldd/search-btcb',
  searchBTTHXLThangCBMonth: 'lhl_bai_tap_rldd/thxl-btcb',
  searchBTTHXLThangCBMonthForKhoi: 'lhl_bai_tap_rldd/thxl-btcb/khoi',
  searchBTTHXLThangCBMonthForLop: 'lhl_bai_tap_rldd/thxl-btcb/lop',
  searchBTTHXLThangCBMonthForDT: 'lhl_bai_tap_rldd/thxl-btcb/dt',
  searchBTTHXLThangNCMonth: 'lhl_bai_tap_rldd/thxl-btnc',
  searchBTTHXLThangNCMonthForKhoi: 'lhl_bai_tap_rldd/thxl-btnc/khoi',
  searchBTTHXLThangNCMonthForLop: 'lhl_bai_tap_rldd/thxl-btnc/lop',
  searchBTTHXLThangNCMonthForDT: 'lhl_bai_tap_rldd/thxl-btnc/dt',
  searchBTThangCBKhoi: 'lhl_bai_tap_rldd/khoi/search-btcb',
  searchBTThangCBKhoiMonth: 'lhl_bai_tap_rldd/khoi/month/search-btcb',
  searchBTThangCBKhoiMonthKS: 'lhl_bai_tap_rldd/khoi/month/ks/search-btcb',
  searchBTThangCBCLBMonthKS: 'lhl_bai_tap_rldd/clb/month/ks/search-btcb',
  searchBTThangCBLop: 'lhl_bai_tap_rldd/lop/search-btcb',
  searchBTThangCBDT: 'lhl_bai_tap_rldd/dt/search-btcb',
  searchBTThangCBLopMonth: 'lhl_bai_tap_rldd/lop/month/search-btcb',
  searchBTThangCBLopMonthKS: 'lhl_bai_tap_rldd/lop/month/ks/search-btcb',
  searchBTThangCBDTMonthKS: 'lhl_bai_tap_rldd/dt/month/ks/search-btcb',
  searchBTThangCBKS: 'lhl_bai_tap_rldd/ks/search-btcb',
  searchBTThangNCKS: 'lhl_bai_tap_rldd/ks/search-btnc',
  searchBTThangNC: 'lhl_bai_tap_rldd/search-btnc',
  searchBTThangNCKhoi: 'lhl_bai_tap_rldd/khoi/search-btnc',
  searchBTThangNCKhoiMonth: 'lhl_bai_tap_rldd/khoi/month/search-btnc',
  searchBTThangNCKhoiMonthKS: 'lhl_bai_tap_rldd/khoi/month/ks/search-btnc',
  searchBTThangNCCLBMonthKS: 'lhl_bai_tap_rldd/clb/month/ks/search-btnc',
  searchBTThangNCLop: 'lhl_bai_tap_rldd/lop/search-btnc',
  searchBTThangNCDT: 'lhl_bai_tap_rldd/dt/search-btnc',
  searchBTThangNCLopMonth: 'lhl_bai_tap_rldd/lop/month/search-btnc',
  searchBTThangNCLopMonthKS: 'lhl_bai_tap_rldd/lop/month/ks/search-btnc',
  searchBTThangNCDTMonthKS: 'lhl_bai_tap_rldd/dt/month/ks/search-btnc',
  updateNCDaily: 'lhl_bai_tap_rldd/nc/daily/update/',
  updateCBDaily: 'lhl_bai_tap_rldd/cb/daily/update/',
  updateTHXLCB: 'lhl_bai_tap_rldd/thxl-btcb/update/',
  updateTHXLNC: 'lhl_bai_tap_rldd/thxl-btnc/update/',
  exportAllKSLHL: 'clb-la-hau-la/export-all',
  exportAllKSLHLOBChecklist: 'clb-la-hau-la/export-all-ob-checklist',
  exportAllKSLHLTemp: 'clb-la-hau-la/export-all-temp',
  exportKhoiKSLHL: 'clb-la-hau-la/export-khoi',
  exportLopKSLHL: 'clb-la-hau-la/export-lop',
  importCLBLHL: 'clb-la-hau-la/import-excel',
  importCLBLHLForKhoi: 'clb-la-hau-la/khoi/import-excel',
  importKSLHLForKhoiLop: 'clb-la-hau-la/khoi-lop/import-excel',
  templateImportCLBLHL: 'template/import-clb-lhl',
  templateImportKhoiLHL: 'template/khoi/import-clb-lhl',
  templateImportKhoiLopLHL: 'template/khoi-lop/import-clb-lhl',
  validateImportCLBLHL: 'clb-la-hau-la/validate-import-excel',
  validateImportCLBLHLForKhoi: 'clb-la-hau-la/khoi/validate-import-excel',
  validateImportCLBLHLForKhoiLop:
    'clb-la-hau-la/khoi-lop/validate-import-excel',
  inactiveCLBLHL: 'clb-la-hau-la/inactive/',
  userChangePassword: 'user/change-password',
  userCLBLHLProfileUpdate: 'clb-la-hau-la/update-profile/',
  updateKSLHLOBChecklist: 'clb-la-hau-la/update-ob-checklist/',
  userCLBLHLProfileCLBUpdate: 'clb-la-hau-la/clb/update-ks/',
  userCLBLHLTempProfileCLBUpdate: 'clb-la-hau-la/clb/update-ks-temp/',
  updateKSLHLTempRequestUpdateCLB:
    'clb-la-hau-la/clb/update-ks-temp-request-update/',
  updateKSLHLTempRejectCLB: 'clb-la-hau-la/clb/update-ks-temp-reject/',
  userCLBLHLProfileKhoiUpdate: 'clb-la-hau-la/khoi/update-ks/',
  userCLBLHLProfileLopUpdate: 'clb-la-hau-la/lop/update-ks/',
  userCLBLHLProfileDTUpdate: 'clb-la-hau-la/dt/update-ks/',
  userCLBLHLTempProfileDTUpdate: 'clb-la-hau-la/dt/update-ks-temp/',
  userCLBLHLProfileCLBAdd: 'clb-la-hau-la/clb/add-ks',
  userCLBLHLProfileKhoiAdd: 'clb-la-hau-la/khoi/add-ks',
  userCLBLHLProfileKhoiLopAdd: 'clb-la-hau-la/khoi-lop/add-ks',
  userCLBLHLProfileDTAddTemp: 'clb-la-hau-la/dt/add-ks',
  refreshUser: 'user/refresh-profile',
  forgetPassword: 'auth/forget-password',
  getUserProfile: 'user/user-profile',
  getKSLHLTempProfile: 'user/ks-lhl-temp',
  searchBQCKhoiLHL: 'lhl-phu-trach-khoi/search',
  addBQCKhoiLHL: 'lhl-phu-trach-khoi/add',
  updateBQCKhoiLHL: 'lhl-phu-trach-khoi/update/',
  inactiveBQCKhoiLHL: 'lhl-phu-trach-khoi/inactive/',
  getUsersWithoutPhuTrachCV: 'clb-cuc-vang/users-without-phu-trach',
  getUsersWithoutPhuTrachTT: 'clb-tuoi-tre/users-without-phu-trach',
  getPhuTrachKhoi: 'lhl-phu-trach-khoi/phu-trach-khoi',
  getPhuTrachKhoiByUsername: 'lhl-phu-trach-khoi/phu-trach-khoi-username',
  searchBCNLopLHL: 'lhl-ban-chu-nhiem-lop/search',
  addBCNLopLHL: 'lhl-ban-chu-nhiem-lop/add',
  updateBCNLopLHL: 'lhl-ban-chu-nhiem-lop/update/',
  inactiveBCNLopLHL: 'lhl-ban-chu-nhiem-lop/inactive/',
  getUsersWithoutCNLopCV: 'clb-cuc-vang/users-without-bcn-lop',
  getUsersWithoutCNLopTT: 'clb-tuoi-tre/users-without-bcn-lop',
  getBCNLop: 'lhl-ban-chu-nhiem-lop/bcn-lop',
  getBCNLopByUsername: 'lhl-ban-chu-nhiem-lop/bcn-lop-username',
  createBaiTapCBTheoThang: 'lhl_bai_tap_rldd/cb/add',
  checkBTCBThangExist: 'lhl_bai_tap_rldd/cb/check-exist',
  createBaiTapNCTheoThang: 'lhl_bai_tap_rldd/nc/add',
  checkBTNCThangExist: 'lhl_bai_tap_rldd/nc/check-exist',
  findBaiTapCBbyThangAndKS: 'lhl_bai_tap_rldd/btcb-thang-by-ks',
  findBaiTapNCbyThangAndKS: 'lhl_bai_tap_rldd/btnc-thang-by-ks',
  sumKSForCLBByGioiTinh: 'clb-la-hau-la/sum/clb/gioi-tinh',
  sumKSForCLB: 'clb-la-hau-la/sum/clb',
  sumKSForKhoiByGioiTinh: 'clb-la-hau-la/sum/khoi/gioi-tinh',
  sumKSForKhoi: 'clb-la-hau-la/sum/khoi',
  sumKSForKhoiLopByGioiTinh: 'clb-la-hau-la/sum/khoi-lop/gioi-tinh',
  sumKSForKhoiLop: 'clb-la-hau-la/sum/khoi-lop',
  sumKSForDTByGioiTinh: 'clb-la-hau-la/sum/dt/gioi-tinh',
  sumKSForDT: 'clb-la-hau-la/sum/dt',
  //start add by 11-Feb-2026
  searchKhoiLopLHL: 'master-data/kl-lhl/search',
  createKhoiLopLHL: 'master-data/kl-lhl/add',
  updateKhoiLopLHL: 'master-data/kl-lhl/update',
  inactiveKhoiLopLHL: 'master-data/kl-lhl/inactive',
  formRequestBLDBPHTPT: 'https://forms.gle/Zuia4Dxayb9sKzGJ8',
  formRequestPhuTrachKhoiBPHTPT: 'https://forms.gle/MAjgB7YSQp4eKJNh9',
  formRequestChuNhiemLopBPHTPT: 'https://forms.gle/5KDiUBCGfV3kPLyZ7',
  formRequestLHLDTBPHT: 'https://forms.gle/Yiqr1f3KYjzQstky7',
  chatGroupSupportBLDBPHTPT: 'https://chat.whatsapp.com/FH7M7sKXBfwEJjdEDx40IX',
  //start update by 22-Mar-2026
  chatGroupSupportPhuTrachKhoiBPHTPT:
    'https://chat.whatsapp.com/LM9J0UlsbaRKjkzVFBH5JQ',
  chatGroupSupportChuNhiemLopK1BPHTPT:
    'https://chat.whatsapp.com/Bpc4R0ozpmaGBMIo4gErKr',
  chatGroupSupportChuNhiemLopK2BPHTPT:
    'https://chat.whatsapp.com/BNC79CorHeNCTSUiITWVsC',
  chatGroupSupportChuNhiemLopK3BPHTPT:
    'https://chat.whatsapp.com/EAeqszaxX713rnBF9e2Y9s',
  chatGroupSupportChuNhiemLopK4BPHTPT:
    'https://chat.whatsapp.com/CE1Iy2BAv9P1LjDbnwaPFw',
  chatGroupSupportLHLDTBPHT: 'https://chat.whatsapp.com/HTQLfObAspZBCrltKlveBB',
  listBLDCLBLHL:
    'https://docs.google.com/spreadsheets/d/1XFimZrjGo6TvIOEPvK8Hvanqgcy-cJXW7HdD5zGDoFs/edit?gid=0#gid=0',
  //start update by 12-Apr-2026
  masterDataKLNamSinh: 'master-data/kl-lhl/nam-by-khoi',
  masterDataDTByKhoiAndNam: 'master-data/kl-lhl/dao-trang-by-khoi-nam',
  masterDataAddKhoiLopDT: 'master-data/kl-lhl/add',
  masterDataGetKhoiLopDTLHL: 'master-data/kl-lhl/khoi-lop-dt-lhl',
  masterDataUpdateKhoiLopDTLHL: 'master-data/kl-lhl/update/',
  masterDataInactiveKhoiLopDTLHL: 'master-data/kl-lhl/inactive/',
  masterDataGroupsLHLK3K4: 'master-data/groups-lhl-k3-k4',
  getUsersWithoutPhuTrachLHL: 'clb-la-hau-la/users-without-phu-trach',
  getUsersWithoutCNLopLHL: 'clb-la-hau-la/users-without-bcn-lop',
  searchBPTKhoiLHLForKhoi: 'lhl-phu-trach-khoi/khoi/search',
  searchBCNLopLHLForKhoi: 'lhl-ban-chu-nhiem-lop/khoi/search',

  //start update by 21-Apr-2026
  searchBCNLopLHLForLOP: 'lhl-ban-chu-nhiem-lop/lop/search',
};
